import { Clock, Zap, Wrench, MessageSquare, HeartHandshake, MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const POINTS = [
    {
        icon: Clock,
        title: "24/7 Availability",
        text: "We're available day and night when you need locksmith assistance.",
    },
    {
        icon: Zap,
        title: "Fast Response",
        text: "We understand that being locked out can be stressful, so we work to reach customers as quickly as possible.",
    },
    {
        icon: Wrench,
        title: "Experienced Service",
        text: "Professional locksmith work requires care, knowledge, and the right equipment.",
    },
    {
        icon: MessageSquare,
        title: "Transparent Communication",
        text: "We explain the work and pricing clearly before proceeding whenever possible.",
    },
    {
        icon: HeartHandshake,
        title: "Respect for Your Property",
        text: "We take care when working on your home, vehicle, or business.",
    },
    {
        icon: MapPin,
        title: "Local Service",
        text: "We're proud to provide locksmith services to customers in our local community.",
    },
];

export const WhyUs = () => (
    <section id="why-us" data-testid="why-us-section" className="bg-white py-20 sm:py-24 lg:py-28">
        <div className="mx-auto w-full max-w-7xl px-5 sm:px-8">
            <SectionHead
                eyebrow="The Difference"
                title="Why Customers Choose Us"
                testId="why-us-heading"
            />
            <div className="mt-14 grid gap-x-10 gap-y-10 md:grid-cols-2 lg:grid-cols-3">
                {POINTS.map((p, i) => (
                    <Reveal key={p.title} delay={(i % 3) * 0.08}>
                        <div data-testid={`why-us-point-${i + 1}`} className="flex items-start gap-4">
                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/30 bg-gold/10 text-gold-dark">
                                <p.icon className="h-5 w-5" />
                            </span>
                            <div>
                                <h3 className="font-display text-lg font-semibold text-slate-900">{p.title}</h3>
                                <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{p.text}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
